function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import Form from "nood-comp/src/comp/form/Form";
import { __post, __put, _get } from "nood-comp/src/net/xhr";
import { useNavigate } from "react-router-dom";
import { routes } from "src/routes/routes";
import SpinnerApple from "nood-comp/src/comp/ui/spinner/Spinner.Apple";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import AddOrEditButton from "nood-comp/src/comp/button/AddOrEditButton";
import FlexCenterCenter from "nood-comp/src/comp/ui/containers/FlexCenterCenter";
import FlexColumn from "nood-comp/src/comp/ui/containers/flex-boxes/FlexColumn";
import CenteredColumnWidth from "nood-comp/src/comp/ui/containers/CenteredColumnWidth";
import APIProcessorFeedback from "nood-comp/src/comp/feedback/APIProcessorFeedback";
import TextField from "nood-comp/src/comp/form/textfield/TextField";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import { __feedback } from "src/app/msg";
import { useSystemsStore } from "src/store/systemsStore";
import OptionPicker from "nood-comp/src/comp/form/dropdown/OptionPicker";
export default function CampusEditor(props) {
  var _Object$keys;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isValid = _useState2[0],
    setIsValid = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    isProcessing = _useState4[0],
    setIsProcessing = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    obj = _useState6[0],
    setObj = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    response = _useState8[0],
    setResponse = _useState8[1];
  var do_ = useURLParam('do');
  var id = useURLParam('id');
  var navigate = useNavigate();
  var is_edit = do_ === 'edit';
  var loadSystemsForDropdown = useSystemsStore(function (state) {
    return state.loadForDropdown;
  });
  var systemsForDropdown = useSystemsStore(function (state) {
    return state.systems_for_dropdown;
  });
  function _submit(finalObj) {
    if (isValid) {
      setIsProcessing(true);
      if (is_edit) {
        __put("".concat(routes.campus, "/").concat(id), {
          body: JSON.stringify(obj)
        }, function (res) {
          setIsProcessing(false);
          __feedback(res);
        });
      } else {
        __post("".concat(routes.campus), {
          body: JSON.stringify(obj)
        }, function (res) {
          var _res$http;
          if ((res === null || res === void 0 || (_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 200) {
            setObj({});
          }
          setIsProcessing(false);
          __feedback(res);
        });
      }
    }
  }
  useEffect(function () {
    loadSystemsForDropdown();
  }, []);
  useEffect(function () {
    if (id && is_edit) {
      _get("/campus/".concat(id), function (res) {
        setObj(res.data);
      });
    }
  }, [is_edit, id]);
  if (do_ === void 0 || do_ === null) {
    return /*#__PURE__*/React.createElement(FlexCenterCenter, null, /*#__PURE__*/React.createElement(SpinnerApple, null));
  }
  if (do_ && is_edit && (obj === void 0 || obj === null || ((_Object$keys = Object.keys(obj)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0)) {
    return /*#__PURE__*/React.createElement(FlexCenterCenter, null, /*#__PURE__*/React.createElement(SpinnerApple, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(APIProcessorFeedback, {
    res: response
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '20px'
    }
  }, /*#__PURE__*/React.createElement(Form, {
    obj: obj,
    __setter: setObj,
    __validSetter: setIsValid,
    __submit: function __submit(finalObj) {
      _submit(finalObj);
    }
  }, /*#__PURE__*/React.createElement(CenteredColumnWidth, {
    width: 400
  }, /*#__PURE__*/React.createElement(FlexColumn, null, /*#__PURE__*/React.createElement(TextField, {
    name: "short_name",
    validations: ['required'],
    icon: "tag",
    label: "Short Name"
  }), /*#__PURE__*/React.createElement(TextField, {
    name: "name",
    validations: ['required'],
    icon: "menu"
  }), /*#__PURE__*/React.createElement(OptionPicker, {
    name: "system_id",
    label: "System",
    options: systemsForDropdown
  }), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  }), /*#__PURE__*/React.createElement(AddOrEditButton, {
    obj: 'Campus',
    edit: is_edit,
    processing: isProcessing,
    valid: isValid
  }))))));
}